import { ElementStyle } from '@/features/canvas/types';

/** A toggleable data field on an item / search card. */
export interface CardFieldDef {
  key: string;
  label: string;
}

/** Item-card fields (header + footer + body), in render order. */
export const ITEM_FIELDS: CardFieldDef[] = [
  { key: 'type', label: 'Type' },
  { key: 'board', label: 'Board' },
  { key: 'epic', label: 'Epic' },
  { key: 'status', label: 'Status' },
  { key: 'priority', label: 'Priority' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'labels', label: 'Labels' },
  { key: 'children', label: 'Sub-items' },
];

/** Search-results table columns, in render order (title is always shown). */
export const SEARCH_FIELDS: CardFieldDef[] = [
  { key: 'key', label: 'Key' },
  { key: 'type', label: 'Type' },
  { key: 'status', label: 'Status' },
  { key: 'priority', label: 'Priority' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'labels', label: 'Labels' },
];

export const cardFields = (kind: string): CardFieldDef[] => (kind === 'search' ? SEARCH_FIELDS : ITEM_FIELDS);

/** A field is shown unless EXPLICITLY disabled — a missing `fields` map (existing cards) shows everything. */
export const fieldOn = (style: ElementStyle | undefined, key: string): boolean => style?.fields?.[key] !== false;
